import React, { useEffect, useRef } from 'react';

export type RuleStatusValue = 'all' | 'active' | 'inactive';
export type RuleEntityTypeValue = 'all' | 'site' | 'virtualTenant';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  value: RuleStatusValue;
  onChange: (v: RuleStatusValue) => void;
  entityType: RuleEntityTypeValue;
  onEntityTypeChange: (v: RuleEntityTypeValue) => void;
}

const RuleStatusFilter: React.FC<Props> = ({ isOpen, onClose, value, onChange, entityType, onEntityTypeChange }) => {
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (ev: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(ev.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) { return null; }

  return (
    <div className="filter-dropdown" ref={dropdownRef}>
      <div className="filter-dropdown__content">
        <h4 className="filter-dropdown__title">Filter Rules</h4>
        <div className="filter-dropdown__form">
          <div className="filter-dropdown__section">
            <h5 className="filter-dropdown__section-title">Rule Type</h5>
            <div className="filter-dropdown__checkbox-group">
              <label className="filter-dropdown__checkbox-label">
                <input type="radio" name="ruleEntityType" checked={entityType === 'all'} onChange={() => { onEntityTypeChange('all'); onClose(); }} />
                <span className="filter-dropdown__checkbox-text">All</span>
              </label>
              <label className="filter-dropdown__checkbox-label">
                <input type="radio" name="ruleEntityType" checked={entityType === 'site'} onChange={() => { onEntityTypeChange('site'); onClose(); }} />
                <span className="filter-dropdown__checkbox-text">Site Rules</span>
              </label>
              <label className="filter-dropdown__checkbox-label">
                <input type="radio" name="ruleEntityType" checked={entityType === 'virtualTenant'} onChange={() => { onEntityTypeChange('virtualTenant'); onClose(); }} />
                <span className="filter-dropdown__checkbox-text">Virtual Tenant Rules</span>
              </label>
            </div>
          </div>
          <div className="filter-dropdown__section">
            <h5 className="filter-dropdown__section-title">Status</h5>
            <div className="filter-dropdown__checkbox-group">
              <label className="filter-dropdown__checkbox-label">
                <input type="radio" name="ruleStatus" checked={value === 'all'} onChange={() => { onChange('all'); onClose(); }} />
                <span className="filter-dropdown__checkbox-text">All</span>
              </label>
              <label className="filter-dropdown__checkbox-label">
                <input type="radio" name="ruleStatus" checked={value === 'active'} onChange={() => { onChange('active'); onClose(); }} />
                <span className="filter-dropdown__checkbox-text">Active</span>
              </label>
              <label className="filter-dropdown__checkbox-label">
                <input type="radio" name="ruleStatus" checked={value === 'inactive'} onChange={() => { onChange('inactive'); onClose(); }} />
                <span className="filter-dropdown__checkbox-text">Inactive</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RuleStatusFilter;
